/** CoStar.Api.ConsumerUserData.Listing.ListorType */
export var ListorType;
(function (ListorType) {
    ListorType[ListorType["None"] = 0] = "None";
    ListorType[ListorType["Owner"] = 1] = "Owner";
    ListorType[ListorType["Broker"] = 2] = "Broker";
    ListorType[ListorType["PropertyManager"] = 3] = "PropertyManager";
})(ListorType || (ListorType = {}));
/** CoStar.Api.ConsumerUserData.Listing.AddListingReasonCodeType */
export var AddListingReasonCodeType;
(function (AddListingReasonCodeType) {
    AddListingReasonCodeType[AddListingReasonCodeType["None"] = 0] = "None";
    AddListingReasonCodeType[AddListingReasonCodeType["InvalidAddressError"] = 1] = "InvalidAddressError";
    AddListingReasonCodeType[AddListingReasonCodeType["AdaCompliance"] = 2] = "AdaCompliance";
    AddListingReasonCodeType[AddListingReasonCodeType["Other"] = 3] = "Other";
})(AddListingReasonCodeType || (AddListingReasonCodeType = {}));
